module.exports = __webpack_public_path__ + "img/bg.d346830.jpg";